import { render, staticRenderFns } from "./BUploader.vue?vue&type=template&id=024fb60c&"
import script from "./BUploader.vue?vue&type=script&lang=js&"
export * from "./BUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports